// K11 (Finar 4.6) — KPI dipnotları: hücre/gösterge yanında üst simge numara (KpiFootnoteMark) ve
// tablo altında numaralı "Dipnotlar" listesi (KpiFootnoteList). Danışman ve portal ortak; kopya
// `KPI_COPY.footnotes` (müşteri yüzeyinde de güvenli — iç not/AI ifadesi yok).
import { footnoteLineText, type KpiFootnoteNumbering } from "@mahir/shared";
import { useKpiFootnotes } from "../../lib/kpi-footnote-context";
import { KPI_COPY } from "../../lib/kpi-ui";

/** `refKey` (`ind:<id>` / `cell:<id>:<entity>:<year>`) için numara varsa `<sup>`; yoksa hiçbir şey. */
export function KpiFootnoteMark({ refKey }: { refKey: string }): JSX.Element | null {
  const numbering = useKpiFootnotes();
  const n = numbering?.refs.get(refKey);
  if (n === undefined || !numbering) return null;
  const entry = numbering.list[n - 1];
  return (
    <sup
      aria-label={KPI_COPY.footnotes.markLabel(n)}
      title={entry?.text}
      style={{ marginLeft: 2, fontSize: "0.65rem", color: "var(--color-primary)", fontWeight: 600 }}
    >
      {n}
    </sup>
  );
}

export function KpiFootnoteList({
  numbering,
}: {
  numbering: KpiFootnoteNumbering | null;
}): JSX.Element | null {
  if (!numbering || numbering.list.length === 0) return null;
  return (
    <section
      aria-label={KPI_COPY.footnotes.title}
      className="text-xs px-3 py-2"
      style={{
        borderTop: "1px solid var(--color-border)",
        color: "var(--color-text-2)",
        flexShrink: 0,
        maxHeight: 160,
        overflowY: "auto",
      }}
    >
      <h3 className="font-semibold" style={{ color: "var(--color-text)", marginBottom: 4 }}>
        {KPI_COPY.footnotes.title}
      </h3>
      <ol style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {numbering.list.map((e) => (
          <li key={e.key}>
            <span style={{ fontWeight: 600 }}>{e.n}.</span> {footnoteLineText(e)}
          </li>
        ))}
      </ol>
    </section>
  );
}
